<template>
  <div v-if="item.isShow && item.roleIsPermission" class="menu-wrapper">
    <template v-if="item.type === 2">
      <el-menu-item :index="item.code" @click="turnToPage(item)">
        <item :icon="item.icon" :title="generateTitle(item.code)" />
      </el-menu-item>
    </template>

    <el-submenu v-if="item.type === 1" ref="submenu" :index="item.code">
      <template slot="title">
        <item :icon="item.icon" :title="generateTitle(item.code)" />
      </template>

      <template v-for="child in item.children">
        <template v-if="child.isShow">
          <menu-item
            :item="child"
            :key="child.code"
            :base-path="resolvePath(child.path)"
            class="nest-menu"
          />
        </template>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import path from "path";
import Item from "./Item";
import { generateTitle } from "@/utils/i18n";
//import routeNameMap from "@/router/RouteNameMap";
export default {
  name: "MenuItem",
  components: { Item },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      onlyOneChild: null,
    };
  },
  created() {},
  methods: {
    resolvePath(routePath) {
      if (routePath == null) {
        return "";
      }
      return path.resolve(this.basePath, routePath);
    },
    turnToPage(params) {
      this.$router.push({ name: params.code });
    },
    generateTitle,
  },
};
</script>
